{
  "validation": {
    "required": "This field is required.",
    "invalid_type": "Invalid type, expected '{{{expected}}}'.",
    "too_small": "Value is too small. Minimum allowed is '{{min}}'.",
    "too_big": "Value is too large. Maximum allowed is '{{max}}'.",
    "invalid_email": "Invalid email format.",
    "invalid_url": "Invalid URL format.",
    "invalid_date": "Invalid date format.",
    "invalid_enum_value": "Invalid selection. Allowed values are '{{values}}'.",
    "invalid_string": "Invalid input, expected string.",
    "invalid_number": "Invalid input, expected number.",
    "passwordMustBeLongerThan": "Password must be longer than {{value}}",
    "passwordMustBeShorterThan": "Password must be shorter than {{value}}",
    "passwordMustContainUppercase": "Password must contain at least one uppercase letter",
    "passwordMustContainLowercase": "Password must contain at least one lowercase letter",
    "passwordMustContainNumber": "Password must contain at least one number",
    "passwordMustContainSpecialCharacter": "Password must contain at least one special character",
    "errors": {
      "invalid_type": "Expected {{expected}}, received {{received}}",
      "invalid_type_received_undefined": "Required",
      "invalid_literal": "Invalid literal value, expected {{expected}}",
      "unrecognized_keys": "Unrecognized key(s) in object: {{keys}}",
      "invalid_union": "Invalid input",
      "invalid_union_discriminator": "Invalid discriminator value. Expected {options}",
      "invalid_enum_value": "Invalid enum value. Expected {{options}}, received {{received}}",
      "invalid_arguments": "Invalid function arguments",
      "invalid_return_type": "Invalid function return type",
      "invalid_date": "Invalid date",
      "custom": "Invalid input",
      "invalid_intersection_types": "Intersection results could not be merged",
      "not_multiple_of": "Number must be a multiple of {{multipleOf}}",
      "not_finite": "Number must be finite",
      "invalid_key": "Invalid key in {{origin}}",
      "invalid_element": "Invalid value in {{origin}}",
      "invalid_string": {
        "email": "Invalid {{validation}}",
        "emoji": "Invalid {{validation}}",
        "url": "Invalid {{validation}}",
        "uuid": "Invalid {{validation}}",
        "ulid": "Invalid {{validation}}",
        "ip": "Invalid {{validation}}",
        "cuid": "Invalid {{validation}}",
        "cuid2": "Invalid {{validation}}",
        "regex": "Invalid",
        "datetime": "Invalid {{validation}}",
        "startsWith": "{{path}} must start with {{startsWith}}",
        "endsWith": "{{path}} must end with {{endsWith}}"
      },
      "too_small": {
        "array": {
          "exact": "{{path}} must contain exactly {{minimum}} element(s)",
          "inclusive": "{{path}} must contain at least {{minimum}} element(s)",
          "not_inclusive": "{{path}} must contain more than {{minimum}} element(s)"
        },
        "string": {
          "exact": "{{path}}  must contain exactly {{minimum}} character(s)",
          "inclusive": "{{path}}  must contain at least {{minimum}} character(s)",
          "not_inclusive": "{{path}}  must contain over {{minimum}} character(s)"
        },
        "number": {
          "exact": "{{path}}  must be exactly {{minimum}}",
          "inclusive": "{{path}} must be greater than or equal to {{minimum}}",
          "not_inclusive": "{{path}} must be greater than {{minimum}}"
        },
        "bigint": {
          "exact": "{{path}} must be exactly {{minimum}}",
          "inclusive": "{{path}} must be greater than or equal to {{minimum}}",
          "not_inclusive": "{{path}} must be greater than {{minimum}}"
        },
        "set": {
          "exact": "Invalid input",
          "inclusive": "Invalid input",
          "not_inclusive": "Invalid input"
        },
        "date": {
          "exact": "Date must be exactly {{minimum, date}}",
          "inclusive": "Date must be greater than or equal to {{minimum, date}}",
          "not_inclusive": "Date must be greater than {{minimum, date}}"
        }
      },
      "too_big": {
        "array": {
          "exact": "{{path}} must contain exactly {{maximum}} element(s)",
          "inclusive": "{{path}} must contain at most {{maximum}} element(s)",
          "not_inclusive": "{{path}} must contain less than {{maximum}} element(s)"
        },
        "string": {
          "exact": "{{path}} must contain exactly {{maximum}} character(s)",
          "inclusive": "{{path}} must contain at most {{maximum}} character(s)",
          "not_inclusive": "{{path}} must contain under {{maximum}} character(s)"
        },
        "number": {
          "exact": "{{path}} must be exactly {{maximum}}",
          "inclusive": "{{path}} must be less than or equal to {{maximum}}",
          "not_inclusive": "{{path}} must be less than {{maximum}}"
        },
        "bigint": {
          "exact": "{{path}} must be exactly {{maximum}}",
          "inclusive": "{{path}} must be less than or equal to {{maximum}}",
          "not_inclusive": "{{path}} must be less than {{maximum}}"
        },
        "set": {
          "exact": "Invalid input",
          "inclusive": "Invalid input",
          "not_inclusive": "Invalid input"
        },
        "date": {
          "exact": "Date must be exactly {{maximum, date}}",
          "inclusive": "Date must be smaller than or equal to {{maximum, date}}",
          "not_inclusive": "Date must be smaller than {{maximum, date}}"
        }
      }
    },
    "validations": {
      "email": "email",
      "emoji": "emoji",
      "url": "url",
      "uuid": "uuid",
      "ip": "up",
      "regex": "regex",
      "uuidv4": "UUIDv4",
      "uuidv6": "UUIDv6",
      "nanoid": "nanoid",
      "guid": "GUID",
      "cuid": "cuid",
      "cuid2": "cuid2",
      "ulid": "ULID",
      "xid": "XID",
      "ksuid": "KSUID",
      "datetime": "ISO datetime",
      "date": "ISO date",
      "time": "ISO time",
      "duration": "ISO duration",
      "ipv4": "IPv4 address",
      "ipv6": "IPv6 address",
      "cidrv4": "IPv4 range",
      "cidrv6": "IPv6 range",
      "base64": "base64-encoded string",
      "base64url": "base64url-encoded string",
      "json_string": "JSON string",
      "e164": "E.164 number",
      "jwt": "JWT",
      "template_literal": "input"
    },
    "types": {
      "function": "function",
      "number": "number",
      "string": "string",
      "nan": "nan",
      "integer": "integer",
      "float": "float",
      "boolean": "boolean",
      "date": "date",
      "bigint": "bigint",
      "undefined": "undefined",
      "symbol": "symbol",
      "null": "null",
      "array": "array",
      "object": "object",
      "unknown": "unknown",
      "promise": "promise",
      "void": "void",
      "never": "never",
      "map": "map",
      "set": "set"
    },
    "custom": {},
    "paymentMethodRequired": "Please select a payment method"
  },
  "appleSignIn": {
    "userCancelled": "Sign-in was cancelled",
    "appleAuthFailed": "Apple authentication failed. Please try again.",
    "backendFailed": "Unable to complete sign-in. Please try again.",
    "networkError": "Network error. Please check your connection and try again.",
    "unavailable": "Apple Sign-in is not available on this device",
    "invalidResponse": "Invalid response from Apple. Please try again.",
    "general": "An unexpected error occurred. Please try again."
  },
  "googleSignIn": {
    "general": "An unexpected error occurred. Please try again."
  },
  "appointment": {
    "tipUpdateFailed": "Failed to update tip",
    "promoCodeUpdateFailed": "Failed to apply promo code",
    "promoCodeRemoveFailed": "Failed to remove promo code",
    "ratingUpdateFailed": "Failed to submit rating",
    "cancelFailed": "Failed to cancel order",
    "unknownError": "Unknown error"
  },
  "calendar": {
    "appleCalendarFailed": "Failed to open Apple Calendar",
    "googleCalendarFailed": "Failed to open Google Calendar",
    "yahooCalendarFailed": "Failed to open Yahoo Calendar",
    "cannotOpenAppleCalendar": "Cannot open Apple Calendar",
    "cannotOpenGoogleCalendar": "Cannot open Google Calendar",
    "cannotOpenYahooCalendar": "Cannot open Yahoo Calendar",
    "appleCalendarNotAvailable": "Apple Calendar is not available in this browser",
    "nativeCalendarNotAvailable": "Native calendar is not available on this platform",
    "unknownError": "An unexpected error occurred. Please try again."
  },
  "email": {
    "noEmailClient": "No email client available. Please install an email app.",
    "failedToOpen": "Failed to open email client. Please try again."
  },
  "cart": {
    "membershipPromoConflict": "Promo codes can't be combined with your membership discount"
  }
}
